<template>
  <div>
    <div v-if="isSignatureDocLinkView && $route.name === 'Document'" id="signature-doc-link-navbar" class="layout vasion-top-nav md-alignment-center-space-between home-vasion-logo-container">
      <div class="vasion-logo-container">
        <VasionLogo id="logo" />
        <VasionButton
          id="login-button"
          :classProp="'primary'"
          @vasionButtonClicked="navigateToLogin"
        >
          Sign In
        </VasionButton>
      </div>
    </div>

    <div v-if="(activeSubAppSet || isVasionHome) && !isSignatureDocLinkView">
      <div v-if="isSignedIn" class="layout vasion-top-nav md-alignment-center-space-between" :class="{ 'home-vasion-logo-container' : isVasionHome }">
        <div v-if="isSavedSearchOpen" class="nav-bar-overlay" @click="toggleSavedSearchDisplay" />
        <div v-if="!isVasionHome" class="md-layout-item vasion-flex-vertical-center">
          <div v-if="canAccessApps" class="round-background-hover" :class="{'round-background-toggled': showAppPicker}">
            <VasionApps id="vasion-apps" class="fillGray apps" @click="toggleAppPicker" />
          </div>
          <div id="vasion-apps">
            <TheAppPicker
              v-if="showAppPicker"
              id="app-picker"
              @toggleAppPicker="toggleAppPicker"
              @loseFocus="closeAppPicker"
            />
          </div>
          <h4 class="product-name">
            {{ activeSubApp }}
          </h4>
        </div>
        <div v-else>
          <div class="vasion-logo-container">
            <router-link to="/vasionHome">
              <VasionLogo id="logo" class="logo-resp-behavior" />
              <VasionLogoMini class="isotype" />
            </router-link>
          </div>
        </div>
        <div class="vasion-flex-end vasion-flex-vertical-center">
          <VasionInput
            v-if="canAccessSearch"
            id="search-bar"
            ref="searchBar"
            v-model="inputValue"
            class="search-bar"
            :name="searchId"
            placeholder="Search Vasion"
            inputType="search-gray"
            :readonly="!isGlobalSearchEnabled"
            :isSearch="true"
            :arrowValue="isSavedSearchOpen"
            :arrowClickCallback="toggleSavedSearchDisplay"
            @keyup.enter="runGlobalSearch"
          />

          <SavedSearchDropDown v-if="isSavedSearchOpen" width="525" />
          <span class="divider" />
          <div
            v-if="isVasionHome"
            id="sign-out"
            class="sign-out"
            @click="signOut"
          >
            Sign Out
          </div>
          <div
            v-if="!isVasionHome"
            id="profile-button"
            class="button-background"
            @click="toggleProfileMenu"
          >
            <a id="user-welcome"><span class="name">{{ displayName }}</span></a>
            <TheProfileMenu
              v-if="showProfileMenu"
              @loseFocus="toggleProfileMenu"
              @openSignature="toggleShowSaveSignatureDialog"
              @openUserSettings="toggleUserSettingsDialog"
            />
          </div>
        </div>
        <md-dialog id="apply-signature-dialog" :md-active.sync="showSaveSignatureDialog" :md-click-outside-to-close="false">
          <AddOrEditSignatureOrInitials @closeAddOrEdit="toggleShowSaveSignatureDialog" />
        </md-dialog>
        <VasionGeneralModal
          id="apply-user-settings"
          :showConfirmButton = false
          :modalType="'slot'"
          :rejectButtonText="'CLOSE'"
          :sync="showUserSettings"
          @noButtonClick="toggleUserSettingsDialog"
        >
          <UserSettings @close="toggleUserSettingsDialog" />
        </VasionGeneralModal>
        <VasionSnackbar
          id="results-snack"
          :showSnackbarBool.sync="showSnackbar"
          :snackbarImage="snackbarImage"
          :snackbarSubTitle="snackbarText"
          :snackbarTitle="snackbarTitle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AddOrEditSignatureOrInitials from '@/components/digitalSignature/AddOrEditSignatureOrInitials.vue'
import SavedSearchDropDown from '@/components/search/SavedSearchDropDown.vue'
import TheAppPicker from '@/components/mainViews/TheAppPicker.vue'
import TheProfileMenu from '@/components/mainViews/TheProfileMenu.vue'
import UserSettings from '@/components/userSettings/UserSettings.vue'

export default {
    name: 'NavBar',
    components: {
      AddOrEditSignatureOrInitials,
      SavedSearchDropDown,
      TheAppPicker,
      TheProfileMenu,
      UserSettings,
    },
    data: function () {
      return {
        globalSearchID: 0,
        inputValue: '',
        showAppPicker: false,
        showProfileMenu: false,
        showSaveSignatureDialog: false,
        showSnackbar: false,
        showUserSettings: false,
        snackbarImage: false,
        snackbarText: '',
        snackbarTitle: '',
      }
    },
    computed: {
        activeSubApp() { return this.$store.state.mainViews.activeSubApp.toUpperCase() },
        activeSubAppSet() { return this.$store.state.mainViews.activeSubApp !== '' },
        canAccessApps() {
          return !this.$store.state.common.appAccess
            || this.$store.state.common.appAccess.length === 0
            || this.$store.state.common.appAccess.length > 1
            || (this.$store.state.common.appAccess.length === 1 && !this.canAccessSearch)
        },
        canAccessSearch() { return this.$store.getters['common/APP_ACCESS_SEARCH'] },
        defaultAppLocalSelection() { return this.$store.state.admin.defaultAppLocalSelection },
        displayName() { return this.$store.state.common.firstName ? this.$store.state.common.firstName : this.$store.state.common.userName },
        fullProfilePic() {
          return ''
        },
        isAdminUser() { return this.$store.getters['common/isAdminUser'] },
        isGlobalSearchEnabled() { return this.$store.state.search.isGlobalSearchEnabled },
        isSavedSearchOpen() { return this.$store.state.mainViews.isSavedSearchOpen },
        isSignatureDocLinkView() { return this.$store.state.common.isSignatureDocLinkView },
        isSignedIn() { return this.$store.state.common.isSignedIn },
        isVasionHome() { return this.$store.state.mainViews.vasionHomeToggle },
        searchId() { return `main-search-${Date.now().toString()}` },
    },
    created() {
      if (this.isSignedIn) {
        this.$store.dispatch('search/getGlobalSearchEnabled')
      }
    },
    methods: {
      closeAppPicker() {
        if (this.showAppPicker === true) {
          this.showAppPicker = false
        }
      },
      navigateToLogin() {
        this.$router.push({ name: 'TheLogin' })
      },
      async runGlobalSearch() {
        if (this.inputValue === '') {
          return
        }
        this.$amplitude.trackEvent('Search Run', { searchType: 'Global'} )
        this.globalSearchID = await this.$store.dispatch('search/getGlobalSearchID')
        const payload = {
          SearchId: this.globalSearchID,
          SearchType: 161,
          FullText: this.inputValue,
        }
        await Promise.all([
          this.$store.dispatch('search/setSelectedSearch', { SearchId: this.globalSearchID, Type: 161, isGlobalSearch: true }),
          this.$store.dispatch('search/setSearchCriteria', payload),
        ])
        this.$router.push({ name: 'SearchResults' }).catch(() => {})
      },
      async signOut() {
        await this.$store.dispatch('common/signOut')
        await this.$amplitude.trackEvent('Logged Out', {
          'isTokenExpired': false,
        })
        this.$router.push({ name: 'TheLogin' })
      },
      toggleAdmin() {
        this.$store.dispatch('mainViews/toggleAdminNav')
      },
      toggleAppPicker() {
          this.showAppPicker = !this.showAppPicker

          if (this.showAppPicker === true) {
            this.showProfileMenu = false
          }
      },
      toggleProfileMenu() {
          this.showProfileMenu = !this.showProfileMenu

          if (this.showProfileMenu === true) {
            this.showAppPicker = false
          }
      },
      toggleSavedSearchDisplay() {
        this.$store.dispatch('mainViews/toggleSavedSearchDropDown', !this.isSavedSearchOpen)
      },
      toggleShowSaveSignatureDialog() {
        this.showSaveSignatureDialog = !this.showSaveSignatureDialog
        this.$emit('showDialog', this.showSaveSignatureDialog)
      },
      toggleUserSettingsDialog() {
        this.showUserSettings = !this.showUserSettings
        this.$emit('showDialog', this.showUserSettings)
      },
    },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';
  .apps {
    margin-right: 21px;
  }
  .button-background {
    width: 121px;
    height: 40px;
    border-radius: 4px;
    border: solid 1px $orange-300;
    background-color: rgba(255, 255, 255, 0.24);
    margin: 0 15px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .divider {
    width: 1px;
    height: 24px;
    opacity: 0.5;
    margin: 0 16px 0 16px;
    // background-color: $grey-300;
  }

  #login-button {
    position: absolute;
    right: 15px;
  }

  #signature-doc-link-navbar {
    width: 100vw;
    background-color: #591559;

    #logo, .vasion-logo-container {
      background-color: #591559;
    }
  }

  .home-vasion-logo-container {
    background-color: $plumb-500;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: left;

    #logo {
      margin-left: 25px;
      width: 95%;
      overflow: visible;
    }

    .sign-out {
      @include Text;
      color: $white;
      cursor: pointer;
      margin-right: 15px;
    }

  }

  .vasion-logo-container {
    background-color: $plumb-500;
    padding-left: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .name {
    width: 57px;
    height: 18px;
    margin-right: 10px;
    font-family: $font-family-medium;
    font-size: 14px;
    font-weight: 500;
    line-height: 0.71;
    color: $orange-300;
  }

  .round-background-hover {
    margin-left: 11px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  .round-background-hover:hover {
    background-color: $plumb-50;
  }

  .round-background-toggled {
    background-color: $plumb-50;
  }

  .roundImage {
    height: 24px;
    width: 24px;
    border-radius: 16px;
  }
  .product-name {
    font-family: $font-family-accent;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 2.4px;
    color: $plumb-300;
    margin: 0 0 0 12px;
  }

  .search-bar{
    width: 525px;
  }

  .layout{
    display: flex;
    justify-content: space-between;
  }

  #profile-button {
    position: relative;
    cursor: pointer;

    & #profile-menu {
      width: 250px;
      position: absolute;
      right: 0;
      top: 40px;
    }
  }
  #vasion-apps {
    position: relative;
    top: 4px;
    left: 4px;
    z-index: 40;
    cursor: pointer;
    & #app-picker {
      position: absolute;
      top: 15px;
      left: -35px;
      z-index: 1000;
    }
  }

  #logo {
    fill: $orange-300;
  }

  .nav-bar-overlay{
    display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,0.4);
      position: fixed;
      z-index: 1;
      cursor: pointer;
  }

  @media (max-width: $tablet){
    .nav-bar-overlay{
      display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,0.4);
      position: fixed;
      z-index: 1;
      cursor: pointer;
    }
    .product-name {
      display: block;
      font-family: $font-family-eurostar;
      font-size: 18px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 2.4px;
      color: $plumb-300;
      margin: 0 0 0 12px;
    }
    .search-bar{
      width: 400px;
    }
    .search-icon {
      display: none;
    }

    .button-background {
      width: 60px;
      height: 40px;
      border-radius: 4px;
      border: solid 1px $orange-300;
      background-color: rgba(255, 255, 255, 0.24);
      margin: 0 15px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .name {
      width: 57px;
      height: 18px;
      margin-right: 0px;
      font-family: $font-family-medium;
      font-size: 14px;
      font-weight: 500;
      line-height: 0.71;
      color: $orange-300;
    }

    .home-vasion-logo-container {
      .sign-out {
        @include Text;
        color: $white;
        text-align: right;
        margin-right: 15px;
      }
    }
  }

  @media (max-width: 950px) {
    .product-name{
      display: none;
    }
    .search-bar {
      width: 250px;
    }
  }

  @media (max-width: $phone){
    .search-bar{
      width: 180px;
    }
    .search-icon {
      display: none;
    }

    .product-name {
      display: none;
    }

    #vasion-apps {
      position: relative;
      top: 4px;
      left: 4px;
      cursor: pointer;
      & #app-picker {
        width: 295px;
        position: absolute;
        top: 15px;
        left: -50px;
        z-index: 1000;
      }
    }

    .home-vasion-logo-container {
      .sign-out {
        @include Text;
        color: $white;
        text-align: right;
      }
    }
  }

  .logo-resp-behavior {
    display: none;
  }

  .isotype {
    display: block;
    fill: $orange-300;
  }
  @media (min-width: 768px) {
    .vasion-logo-container {
      width: 256px;
      padding-left: none;
    }
    .divider {
      margin: 0 28px 0 16px;
    }
    .isotype {
      display: none!important;;
    }
    .logo-resp-behavior {
      display: block!important;;
    }
  }
</style>
